import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const NeurosurgeryIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.9282 40C79.9282 61.8153 62.2435 79.5 40.4282 79.5C18.613 79.5 0.928223 61.8153 0.928223 40C0.928223 18.1848 18.613 0.5 40.4282 0.5C62.2435 0.5 79.9282 18.1848 79.9282 40Z'
    />
    <g clipPath='url(#clip0_414_9146)'>
      <path
        d='M54.1524 39.0867C53.9086 39.0867 53.6697 38.968 53.5254 38.7493L52.2075 36.7501H50.2409C49.8266 36.7501 49.4907 36.4143 49.4907 35.9999C49.4907 35.5855 49.8266 35.2498 50.2409 35.2498H52.6114C52.8636 35.2498 53.0989 35.3765 53.2378 35.587L54.778 37.9236C55.0061 38.2695 54.9105 38.7348 54.5646 38.9628C54.4374 39.0465 54.2941 39.0867 54.1524 39.0867Z'
        fill='#6CBFF8'
      />
      <path
        d='M61.8484 36.7501H60.3871C60.0869 36.7501 59.8156 36.5712 59.6975 36.2953L58.3152 33.0677C58.1521 32.6868 58.3286 32.2459 58.7095 32.0827C59.0902 31.9197 59.5313 32.0962 59.6944 32.4769L60.8819 35.2498H61.8485C62.2627 35.2498 62.5986 35.5856 62.5986 36C62.5986 36.4143 62.2626 36.7501 61.8484 36.7501Z'
        fill='#6CBFF8'
      />
      <path
        d='M55.655 38.918C55.564 38.918 55.4716 38.9013 55.3819 38.8663C54.9961 38.7153 54.8056 38.2803 54.9565 37.8944L57.059 32.5192C57.21 32.1334 57.645 31.9426 58.0309 32.0939C58.4167 32.2448 58.6072 32.6798 58.4563 33.0657L56.3538 38.441C56.238 38.737 55.9548 38.918 55.655 38.918Z'
        fill='#6CBFF8'
      />
      <path
        d='M51.4236 45.3005L49.0318 41.4953C48.8025 41.1303 48.7985 40.6674 49.0215 40.2985L49.9156 38.8201C51.1935 36.7068 51.5904 34.162 50.9515 31.7766C49.0216 24.5706 42.4462 19.2644 34.6314 19.2644H28.9901C21.5092 19.2644 15.4429 25.3216 15.4282 32.7991C15.4221 35.9232 16.527 38.9481 18.474 41.3913L20.9497 44.4978C21.587 45.2976 21.8327 46.3407 21.6192 47.3407L18.9476 59.8564C18.8678 60.2306 19.1531 60.5834 19.5358 60.5834H33.4879C33.7778 60.5834 34.0264 60.3766 34.0793 60.0916L35.1785 54.1614L43.5646 55.7752C44.8486 56.0831 46.1425 55.3057 46.4736 54.0275L47.5945 49.6989C47.6838 49.3539 47.9145 49.0625 48.2299 48.8964L50.8247 47.5299C51.6354 47.1028 51.9111 46.0762 51.4236 45.3005Z'
        fill='#FAA68E'
      />
      <path
        d='M35.175 54.1822L32.7865 53.7226C32.5533 53.6777 32.3282 53.8314 32.2849 54.0649L31.0767 60.5834H33.4884C33.7783 60.5834 34.0268 60.3766 34.0798 60.0917L35.175 54.1822Z'
        fill='#E09380'
      />
      <path
        d='M51.4236 45.3004L49.0318 41.4953C48.8025 41.1303 48.7985 40.6673 49.0215 40.2985L49.9156 38.82C51.2109 36.678 51.5877 34.0966 50.9261 31.6824C49.1064 25.0426 43.3368 20.0369 36.3008 19.3467C42.0304 20.9204 46.5426 25.4351 48.1117 31.1666C48.7722 33.5795 48.3946 36.1591 47.1 38.2998L46.206 39.7784C45.9829 40.1472 45.9869 40.6102 46.2163 40.9752L48.6081 44.7803C49.0957 45.556 48.8198 46.5827 48.0092 47.0096L45.4143 48.3762C45.099 48.5423 44.8682 48.8337 44.7789 49.1787L43.658 53.5073C43.365 54.6384 42.3179 55.3767 41.191 55.3184L43.5646 55.7751C44.8486 56.0831 46.1425 55.3057 46.4736 54.0275L47.5945 49.6989C47.6838 49.3539 47.9145 49.0625 48.2299 48.8964L50.8247 47.5298C51.6354 47.1027 51.9111 46.0761 51.4236 45.3004Z'
        fill='#E09380'
      />
      <path
        d='M28.724 36.2798V40.6457C28.724 41.696 28.2911 42.6997 27.5273 43.4206L27.0482 43.8727C26.2352 44.64 25.7744 45.7084 25.7744 46.8262V50.5322C25.7744 50.7816 25.9766 50.9838 26.226 50.9838H28.2723C28.5217 50.9838 28.7239 50.7816 28.7239 50.5322V48.5582C28.7239 46.9986 29.6711 45.591 31.1274 44.9868L33.4581 44.0198C34.9144 43.4156 35.8616 42.008 35.8616 40.4483V33.5984L28.724 36.2798Z'
        fill='#F9DBEB'
      />
      <path
        d='M34.4495 35.8653H41.7366C45.134 35.8653 46.6429 32.3237 44.2162 30.3822C44.5936 26.9309 41.3833 24.7199 39.5641 24.9896C38.3921 22.8325 34.6651 21.9522 32.9395 22.9768C30.7825 21.2512 25.4976 22.5993 24.2033 25.2417C21.9385 25.7809 19.35 28.6929 20.2668 31.1736C17.5166 33.4924 20.806 41.0961 25.6594 40.0175C28.5715 41.204 34.3417 41.1501 34.4495 35.8653Z'
        fill='#DE5791'
      />
      <path
        d='M27.812 40.5662C30.7606 40.9466 34.3642 40.0316 34.4492 35.8655H32.7903C32.4116 35.8655 32.0942 36.1494 32.0488 36.5254C31.7331 39.1387 29.873 40.2758 27.812 40.5662Z'
        fill='#C4237C'
      />
      <path
        d='M44.8029 30.1491C45.1803 26.6978 41.97 24.4868 40.1508 24.7565C39.0879 22.8002 35.4409 22.086 33.4839 22.7342C35.5614 23.0593 37.8866 24.1341 38.296 25.5566C40.1151 25.287 43.3255 27.498 42.948 30.9493C45.3747 32.8906 43.1115 35.8654 39.3811 35.8654H41.7361C44.4837 35.8654 46.3801 33.3964 45.7215 31.425C45.6407 31.1833 45.213 31.296 45.0523 31.0748C44.9029 30.8692 45.0264 30.328 44.8029 30.1491Z'
        fill='#C4237C'
      />
      <path
        d='M31.1773 35.1055C31.5916 35.1055 31.9275 34.7697 31.9275 34.3554C31.9275 33.941 31.5916 33.6052 31.1773 33.6052H29.5268C27.4066 33.6052 25.6816 35.3302 25.6816 37.4504V40.0266C26.1263 40.2059 26.6363 40.3563 27.1819 40.4639V37.4505C27.1819 36.1576 28.2338 35.1056 29.5267 35.1056L31.1773 35.1055Z'
        fill='#C4237C'
      />
      <path
        d='M44.8092 30.1543L44.3398 30.7527C43.7952 31.4469 42.9768 31.845 42.0945 31.845H41.4567C41.0424 31.845 40.7065 32.1808 40.7065 32.5952C40.7065 33.0095 41.0424 33.3453 41.4567 33.3453H42.0945C43.4407 33.3453 44.6894 32.7379 45.5203 31.6787L45.7206 31.4234C45.5654 30.9599 45.2692 30.524 44.8092 30.1543Z'
        fill='#C4237C'
      />
      <path
        d='M45.5204 31.6785L45.7208 31.4231C45.5511 30.9165 45.2274 30.49 44.8094 30.1541L44.34 30.7524C44.1013 31.0567 43.81 31.304 43.4839 31.486C43.8431 31.9494 43.9867 32.446 43.9489 32.9325C44.5541 32.6479 45.0928 32.2236 45.5204 31.6785Z'
        fill='#A71E6A'
      />
      <path
        d='M36.441 28.2457C36.8552 28.2457 37.1911 27.9099 37.1911 27.4956C37.1911 27.0812 36.8552 26.7454 36.441 26.7454H34.5739C33.6696 26.7454 32.9339 26.0097 32.9339 25.1053V22.9727C32.528 22.6498 32.0122 22.4351 31.4336 22.3169V25.1053C31.4336 26.8369 32.8424 28.2457 34.574 28.2457H36.441Z'
        fill='#C4237C'
      />
      <path
        d='M30.8566 30.7553C31.2709 30.7553 31.6068 30.4195 31.6068 30.0052C31.6068 29.5908 31.2709 29.255 30.8566 29.255H29.8624C29.1996 29.255 28.6603 28.7158 28.6603 28.053V27.7561C28.6603 25.8007 27.2373 24.1724 25.3728 23.8496C24.8653 24.255 24.4571 24.7233 24.2032 25.242C24.1715 25.2496 24.1394 25.2592 24.1074 25.2677C24.1657 25.2821 24.2261 25.2907 24.2888 25.2907H24.6947C26.0541 25.2907 27.16 26.3966 27.16 27.756V28.0529C27.16 29.543 28.3724 30.7553 29.8624 30.7553H30.8566Z'
        fill='#C4237C'
      />
      <path
        d='M24.445 32.1236C22.8326 32.7688 21.1284 32.1257 20.2645 31.1663C20.2654 31.1687 20.266 31.1712 20.2669 31.1737C19.8705 31.5079 19.6003 31.9523 19.4414 32.4643C20.3392 33.2986 21.6542 33.8886 23.0807 33.8886C23.7086 33.8886 24.3581 33.7744 25.0022 33.5167C25.3869 33.3628 25.5739 32.9263 25.42 32.5417C25.2663 32.1569 24.8299 31.9696 24.445 32.1236Z'
        fill='#C4237C'
      />
      <path
        d='M65.1505 36.1789C65.2404 35.2748 64.5804 34.4689 63.6763 34.3789C62.7721 34.289 61.9662 34.949 61.8763 35.8531C61.7863 36.7573 62.4463 37.5632 63.3505 37.6531C64.2546 37.7431 65.0605 37.0831 65.1505 36.1789Z'
        fill='#EEC06B'
      />
      <path
        d='M56.823 39.8935C56.9187 38.9316 56.2166 38.0743 55.2547 37.9786C54.2928 37.8829 53.4355 38.5851 53.3398 39.5469C53.2441 40.5088 53.9463 41.3662 54.9081 41.4619C55.87 41.5576 56.7273 40.8554 56.823 39.8935Z'
        fill='#FFA95F'
      />
      <path
        d='M60.116 31.4463C60.2117 30.4844 59.5095 29.627 58.5477 29.5313C57.5858 29.4356 56.7285 30.1378 56.6328 31.0997C56.5371 32.0616 57.2392 32.9189 58.2011 33.0146C59.163 33.1103 60.0203 32.4081 60.116 31.4463Z'
        fill='#FFA95F'
      />
      <path
        d='M65.2552 36.1894C65.3509 35.2275 64.6487 34.3702 63.6868 34.2745C62.725 34.1788 61.8676 34.881 61.7719 35.8428C61.6762 36.8047 62.3784 37.6621 63.3403 37.7578C64.3021 37.8535 65.1595 37.1513 65.2552 36.1894Z'
        fill='#FFA95F'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_9146'>
        <rect width='50' height='50' fill='white' transform='translate(15.4282 15)' />
      </clipPath>
    </defs>
  </svg>
));
NeurosurgeryIcon.displayName = 'NeurosurgeryIcon';

export default NeurosurgeryIcon;
